import React from 'react';
import {Link} from 'react-router-dom';
import { Capacitor } from '@capacitor/core';

import TelegramJoinButton from '../components/buttons/TelegramJoinButton'
import ShareButtons from './ShareThisButtons'

function FooterIOS(){
  return (
    <div className="mt-5 footer-ios">
      {/*<div className='row my-2'>
        <div className="col-12 my-2 text-center">
          <TelegramJoinButton theme='dark'></TelegramJoinButton>
        </div>
      </div>
      <div className='row'>
        <div className="col-12 my-2 text-center my-auto">
          <Follow username="CryptoWavesApp" options={{ size: "large" }} />
        </div>
  </div>*/}

      <div className="row no-gutters justify-content-center align-items-center">
        <div className="col-12 text-center justify-content-center align-items-center">
          <span className="small text-muted">
            <span className="small">
              <a href="/blog/privacy">Privacy</a>
              <span className="text-muted"> • </span>
              <a href="/blog/terms">Terms of Service</a>
              <span className="text-muted"> • </span>
              <a href="/blog/support">Support</a>
            </span>
          </span>
        </div>
      </div>
      <div className="row no-gutters justify-content-center align-items-center">
        <div className="col-12 text-center justify-content-center align-items-center">
          <span className="small text-muted">
            <span className="small">
              © 2021-2026, CryptoWaves.App
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default FooterIOS;
